import { z } from 'zod';

export const applicationsPendingReviewSchema = z.object({
  applicationsPendingReview: z.number(),
});

export type ApplicationsPendingReviewResponse = z.infer<typeof applicationsPendingReviewSchema>;

export const applicationAverageReactionTimeSchema = z.object({
  applicationAverageReactionTime: z.number(),
});

export type ApplicationAverageReactionTimeResponse = z.infer<
  typeof applicationAverageReactionTimeSchema
>;

export const checkoutsPendingReviewSchema = z.object({
  checkoutsPendingReview: z.number(),
});

export type CheckoutsPendingReviewResponse = z.infer<typeof checkoutsPendingReviewSchema>;

export const checkoutsAverageAcceptanceTimeSchema = z.object({
  checkoutsAverageAcceptanceTime: z.number(),
});

export type CheckoutsAverageAcceptanceTimeResponse = z.infer<
  typeof checkoutsAverageAcceptanceTimeSchema
>;

export const fillRateOfUpcomingShiftsSchema = z.object({
  fillRateOfUpcomingShifts: z.number(),
});

export type FillRateOfUpcomingShiftsResponse = z.infer<typeof fillRateOfUpcomingShiftsSchema>;

export const fillRateForFlexPoolWorkersSchema = z.object({
  fillRateForFlexPoolWorkers: z.number(),
});

export type FillRateForFlexPoolWorkersResponse = z.infer<typeof fillRateForFlexPoolWorkersSchema>;

export const daysPlannedAheadSchema = z.object({
  daysPlannedAhead: z.number(),
});

export type DaysPlannedAheadResponse = z.infer<typeof daysPlannedAheadSchema>;

export const medianShiftPublishingWindowSchema = z.object({
  medianShiftPublishingWindow: z.number(),
});

export type MedianShiftPublishingWindowResponse = z.infer<typeof medianShiftPublishingWindowSchema>;

export type DashboardAnalyticsResponse = Partial<
  ApplicationsPendingReviewResponse &
    ApplicationAverageReactionTimeResponse &
    CheckoutsPendingReviewResponse &
    CheckoutsAverageAcceptanceTimeResponse &
    FillRateOfUpcomingShiftsResponse &
    FillRateForFlexPoolWorkersResponse &
    DaysPlannedAheadResponse &
    MedianShiftPublishingWindowResponse
>;

export const openCheckoutsSchema = z.object({
  openCheckouts: z.number().optional(),
});

export type OpenCheckoutsResponse = z.infer<typeof openCheckoutsSchema>;

export const unfulfilledShiftsSchema = z.object({
  fullFillYourWork: z.array(z.string()).optional(),
});

export type UnfulfilledShiftsResponse = z.infer<typeof unfulfilledShiftsSchema>;

export const notPlannedWorkSchema = z.object({
  notPlannedWork: z.boolean().optional(),
});

export type NotPlannedWorkResponse = z.infer<typeof notPlannedWorkSchema>;

export type DashboardTodoResponse = Partial<
  OpenCheckoutsResponse & UnfulfilledShiftsResponse & NotPlannedWorkResponse
>;

export const shiftOverviewChartResponseSchema = z.array(
  z.object({
    label: z.string(),
    value: z.number(),
  })
);

export type ShiftOverviewChartResponse = z.infer<typeof shiftOverviewChartResponseSchema>;

export const IntervalSchema = z.enum(['daily', 'weekly', 'monthly']);
export type Interval = z.infer<typeof IntervalSchema>;
